// extracted by mini-css-extract-plugin
export var centerText = "_be-7";
export var container = "_be-0";
export var doughnutContainer = "_be-6";
export var legend = "_be-9";
export var legendItemColorDisplay = "_be-a";
export var legendItemLabel = "_be-b";
export var lg = "_be-5";
export var maxWidth = "_be-8";
export var md = "_be-4";
export var sm = "_be-3";
export var xs = "_be-2";
export var xxs = "_be-1";